import { useState, useEffect } from "react";
import "./OrderConfirmation.css";
import useResponsive from "../../hooks/useResponsive";
import MobileTopBar from "../../components/mobile/MobileTopBar";
import Footer from "../../components/shared/Footer";
import { successPage, checkout, various } from "../../Data/siteContent";

const OrderConfirmation = () => {
  const [order, setOrder] = useState(null);
  const isMobile = useResponsive();

  useEffect(() => {
    const saved = sessionStorage.getItem("lastOrder");
    if (saved) {
      setOrder(JSON.parse(saved));
      sessionStorage.removeItem("lastOrder");
    }
  }, []);

  if (!order) {
    return (
      <div className="confirmation-page">
        {isMobile && <MobileTopBar />}
        <div className="confirmation-empty">
          <p>{successPage.orderNotFound}</p>
        </div>
        {isMobile && <Footer />}
      </div>
    );
  }

  const cartItemClass = isMobile ? "cart-item-checkout-mobile" : "cart-item-checkout";
  const availableClass = isMobile ? "available-shipping-mobile" : "available-shipping";

  const shippingBlock = (
    <div className={`confirmation-left ${isMobile ? "confirmation-left-mobile" : ""}`}>
      <h2>{successPage.shippingDetails}</h2>
      <div className="confirmation-field">
        <label>{checkout.firstNameLabel.replace(" *", "")}</label>
        <span>{order.firstName}</span>
      </div>
      <div className="confirmation-field">
        <label>{checkout.lastNameLabel.replace(" *", "")}</label>
        <span>{order.lastName}</span>
      </div>
      <div className="confirmation-field">
        <label>{checkout.countryLabel.replace(" *", "")}</label>
        <span>{order.country}</span>
      </div>
      <div className="confirmation-field">
        <label>{checkout.addressLine1Label.replace(" *", "")}</label>
        <span>{order.address}</span>
      </div>
      {order.apartment && (
        <div className="confirmation-field">
          <label>{checkout.addressLine2Label.replace(" (optional)", "")}</label>
          <span>{order.apartment}</span>
        </div>
      )}
      <div className="confirmation-field">
        <label>{checkout.cityLabel.replace(" *", "")}</label>
        <span>{order.city}</span>
      </div>
      <div className="confirmation-field">
        <label>{checkout.zipCodeLabel.replace(" *", "")}</label>
        <span>{order.zipCode}</span>
      </div>
      <div className="confirmation-field">
        <label>{checkout.phoneLabel.replace(" *", "")}</label>
        <span>{order.phone}</span>
      </div>
      <div className="confirmation-field">
        <label>{checkout.emailLabel.replace(" *", "")}</label>
        <span>{order.email}</span>
      </div>
    </div>
  );

  const orderBlock = (
    <div className={`confirmation-right ${isMobile ? "confirmation-right-mobile" : ""}`}>
      <h2>{successPage.title}</h2>
      <p className="confirmation-message">{successPage.message}</p>

      {(order.commercialId || order.timestamp) && (
        <div className="confirmation-order-info">
          {order.commercialId && (
            <p>
              <strong>{successPage.orderReference}:</strong> {order.commercialId}
            </p>
          )}
          {order.timestamp && (
            <p>
              <strong>{successPage.orderDate}:</strong>{" "}
              {new Date(order.timestamp).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </p>
          )}
        </div>
      )}

      <h3>{successPage.orderSummary}</h3>
      {order.items.map((item, index) => (
        <div key={index} className={cartItemClass}>
          {isMobile ? (
            <div>
              <strong>Product:</strong>
              <div>
                {item.name} - <span>{item.secondTitle}</span>
              </div>
            </div>
          ) : (
            <>
              <h3>{item.name}</h3>
              {item.secondTitle}
            </>
          )}
          {item.image ? (
            <img src={item.image} alt={item.name} className="cart-item-image" />
          ) : (
            <p>{various.noImageAvailable}</p>
          )}
          <p>
            <strong>Price:</strong> {item.price}
          </p>
          {item.quantity > 1 && (
            <p>
              <strong>{various.quantityLabel}:</strong> {item.quantity}
            </p>
          )}
          <div className={availableClass}>{checkout.usuallyAvailable}</div>
        </div>
      ))}

      <p className={isMobile ? "total-text-mobile-checkout" : ""}>
        <strong>{checkout.shippingCostsLabel}</strong> {Math.round(order.shipping)}€
      </p>
      <p className={isMobile ? "total-text-mobile-checkout" : ""}>
        <strong>{checkout.totalLabel}</strong> {Math.round(order.total)}€
      </p>
    </div>
  );

  return (
    <div className="confirmation-page">
      {isMobile && <MobileTopBar />}
      <div className={`confirmation-container ${isMobile ? "confirmation-container-mobile" : ""}`}>
        {orderBlock}
        {shippingBlock}
      </div>
      {isMobile && (
        <>
          <div className="confirmation-spacer" />
          <Footer />
        </>
      )}
    </div>
  );
};

export default OrderConfirmation;
